<template>
  <a
    :href="url"
    target="_blank"
    class="new-platform-btn"
    v-if="url"
  >
    <span class="ai-badge">AI</span>
    <span class="btn-text">切换天眼AI</span>
  </a>
</template>

<script>
const FIXED_ROUTES = ['realtime', 'pay', 'new', 'online', 'report', 'test', 'consume', 'version', 'reflow', 'experience', 'veteran', 'fashion']
const ALLOWED_PROJS = ['d90', 'l22', 'l36', 'd30', 'l10', 'd10', 'l28', 'l33']

export default {
  computed: {
    proj() {
      return this.$service.PROJ_CODE
    },
    url() {
      if (!this.proj || !ALLOWED_PROJS.includes(this.proj)) return null

      if (FIXED_ROUTES.includes(this.$route.name)) {
        return `https://ux.leihuo.netease.com/dc3/${this.proj}/${this.$route.name}`
      }

      if (this.$route.name === 'page' && this.$route.query.id) {
        return `https://ux.leihuo.netease.com/dc3/${this.proj}/subjects/${this.proj}.${this.$route.query.id}`
      }

      return null
    }
  }
}
</script>

<style lang="less" scoped>
.new-platform-btn {
  position: fixed;
  right: 100px;
  bottom: 50px;
  z-index: 10;
  background: linear-gradient(135deg, #6c5ce7, #a29bfe);
  color: #fff;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 2px 12px rgba(108, 92, 231, 0.35);
  transition: all 0.2s;

  &:hover {
    box-shadow: 0 4px 16px rgba(108, 92, 231, 0.5);
    transform: translateY(-1px);
    color: #fff;
  }

  .ai-badge {
    display: inline-block;
    background: #fff;
    color: #6c5ce7;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 5px;
    border-radius: 4px;
    line-height: 1;
  }

  .btn-text {
    font-weight: 500;
  }
}
</style>
